import {
  HttpEvent,
  HttpClient,
  HttpContext,
  HttpContextToken,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
import {
  IAdminRoleData,
  IGetAdminRoleResponse,
} from "src/app/store/models/adminRole.model";
import {
  FindingDetails,
  ActionResponse,
  ActionsResponse,
  FindingNoteModel,
  FindingsResponse,
  ActionResponseModel,
  FindingResponseModel,
  IChangeAssessmentStatus,
  FindingNotesResponseModel,
  GetAllAssessmentResponseModel,
  FindingMaterialManagementModel,
  MaterialRequestUpdateToEditorsRequestBody,
} from "src/app/store/models/assesment.model";
import {
  AssetDemolishedResponseModel,
  AssetModel,
  AssetRegisterResponseModel,
  AssetResponseModel,
  AssetsResponseModel,
  ERPAssetsResponseModel,
  GetAllUniqueAssetTypeFromSAPAssetMasterResponseModel,
  GetAssetsResponseModel,
  MapSapAssetsConfigurationModelModel,
  MasterAssetResponseModel,
  RemoveAssetsResponseModel,
  SiteInfoModel,
  SitesResponseModel,
} from "src/app/store/models/asset.model";
import { whoIsWhoResponseModel } from "src/app/store/models/bog-site-info-model";
import {
  SecurityPoiModel,
  SecurityCategoryModel,
  AddSecurityPoiResponseModel,
  DeleteSecurityPoiResponseModel,
  UpdateSecurityPoiResponseModel,
  AddSecurityCategoryResponseModel,
  DeleteSecurityCategoryResponseModel,
  UpdateSecurityCategoryResponseModel,
} from "src/app/store/models/site-security-mapping.model";
import {
  SecurityMappingResponseModel,
  SecurityRouteSaveRequestModel,
  SecurityLocationSaveRequestModel,
  SecurityMappingDeleteRequestModel,
} from "src/app/store/models/security-mapping.model";
import {
  ALLConnectionResponseModel,
  AssetConfigurationMappingModel,
  AssetListResponseModel,
  ConnectionAssetConfigurationModel,
  ConnectionAssetConfigurationResponseModel,
  ConnectionModel,
  ConnectionResponseModel,
  LogsResponseModel,
  UploadedXlsxConfigurationResponseModel,
} from "src/app/store/models/connection.model";
import {
  DashboardResponseModel,
  FullCalendarResponseModel,
} from "src/app/store/models/dashboard.model";
import {
  ActivitiesModelResponse,
  AddEIUserResponse,
  BusinessSegmentBySiteResponse,
  DeleteGuidanceResponse,
  EiAddUpdateApiResponse,
  EICountryModelResponse,
  EIEnergyTypesModelResponse,
  EIMyAssignRoleResponse,
  EiProceduresResponse,
  EiRatingResponse,
  EIRatingUpdateModel,
  EISitesByCountryModelResponse,
  EIStepNoModelResponse,
  EIUserModelResponse,
  EnergryIsolationProcedureAPIDataModel,
  GetGadEmployeesFromBogResponse,
  IsolationDeviceTypeResponse,
  LocationCategoryModelResponse,
  LocationsByLevelResponse,
  SiteModel,
  UpdateEiProceduresResponse,
} from "src/app/store/models/energy-isolation.model";
import {
  AddGuidanceResponse,
  Guidance,
} from "src/app/store/models/guidance.model";
import {
  ActiveGruResponse,
  ActiveSiteResponse,
  ActiveUitResponse,
  CheckInSitesResponse,
  UpdateSapKeyCodeResponseModel,
} from "src/app/store/models/location.model";
import {
  BannedWasteItem,
  HazardItem,
  HazardsInventoryItem,
  MaterialControlConfigModel,
  MaterialRegistrationItem,
  OCRLabelMapping,
} from "src/app/store/models/material-master.model";
import {
  AddOCRNotMappedPropertyReqBodyModel,
  MM_ControlSheetIntroResponseModel,
  MM_ControlSheetToPdfDataModel,
  MM_ControlSheetToPdfResponseModel,
  MM_Hazard_EnvironmentModel,
  MM_Hazard_HealthModel,
  MM_HazardsResponseModel,
  MM_InventoryListResponseModel,
  MM_InventoryModel,
  MM_MaterialTypesResponseModel,
  Update_MM_InventoryBodyDataModel,
  Update_MM_InventoryResponseModel,
} from "src/app/store/models/materialManagement.model";
import { NotificationResponse } from "src/app/store/models/notification.model";
import {
  ActiveEmailJobsResponse,
  ActiveJobsResponse,
  BulkEmailStatusResponse,
  CriticalIncidentPolished,
  GenerateReportRequest,
  GenerateReportResponse,
  GenerateStatusReportResponse,
  highlowScoreRequest,
  HighLowScoreResponse,
  LocationTrackingResponse,
  PerformanceData,
  PerformanceIncidentCiLogResponse,
  PerformanceLocationResponse,
  PerformancePolishTextReq,
  PerformancePolishTextResp,
  RecallRequest,
  RecallResponse,
  ReportingDateResponse,
  SystemActiveJobsResponse,
} from "src/app/store/models/performance-data.model";
import { UserEmailResponse } from "src/app/store/models/performance-email-report.model";
import {
  AddUpdateRoleMasterResponse,
  RoleMasterModel,
} from "src/app/store/models/role.model";
import {
  DefaultURLResponseModel,
  SAPConfigurationResponseModel,
  TestConnectionForAWSCognitoResponseModel,
  TestConnectionForAWSSQSResponseModel,
  TestConnectionForSAPNotificationResponseModel,
  ValidatePullSystemResponseModel,
} from "src/app/store/models/sap.model";
import {
  ApiResponse,
  BogUserModel,
  ChangeRoleModel,
  ChangeRoleResponseModel,
  EILanguageUpdate,
  EIUserLanguageModel,
  FcmToken,
  GetAllBogProUsersResponseModel,
  SignOutResponse,
  UpdateSingleUserModel,
  UpdateUserModel,
  UserModel,
  UserResponseModel,
} from "src/app/store/models/user.model";
import {
  BogActionFilter,
  BogActionsRequest,
  ActionClosureModel,
  ReAssignActionModel,
  BogTodoActionsResponse,
  BogActionsResponseModel,
  BogFollowUpActionsResponse,
} from "src/app/store/models/action-management.model";
import { ApiEndPoint } from "./endPoint";
import { Observable, shareReplay } from "rxjs";
import { inject, Injectable } from "@angular/core";
import { FileModel } from "src/app/store/models/file.model";
import { TenantService } from "../tenant-service/tenant.service";
import { TenantInfoModel } from "src/app/store/models/tenant.model";
import { StorageService } from "../storage-service/storage.service";
import { HttpResponseModel } from "src/app/store/models/base.model";
import { TranslationsResponseModel } from "src/app/store/models/language.model";
import { ApiResponseModel } from "src/app/store/models/location-hierarchy.model";
import { CurrencyInformationResponseModel } from "src/app/store/models/currency.model";
import { SyncApppDetailsResponseModel } from "src/app/store/models/syncApppDetails.model";
import { MM_ControlInventoryModel } from "src/app/store/models/mmControlManagement.model";
import { UpdateMaterialAssessmentStatusResponseModel } from "src/app/store/models/mmAssessment.model";
import type { NewThisMonthConfig } from "src/app/services/performance-email-template/performance-email-template.service";
import {
  SubAssetMasterDataModel,
  AddMasterSubAssetResponse,
  AllAssetMasterDataResponse,
  GetAssetMasterByIdResponse,
  SubAssetMasterAssetResponse,
  DeleteMasterSubAssetResponse,
  AllSubAssetMasterDataResponse,
  GetMasterSubAssetByIdResponse,
  AddSubAssetToMasterAssetPayload,
  RemoveSubAssetFromMasterAssetPayload,
} from "src/app/store/models/masterData.model";
import {
  ZoneMasterTypeModel,
  AddZoneTypeResponseModel,
  GetZoneTypesResponseModel,
  ProductLineMasterTypeModel,
  AddProductLineResponseModel,
  DeleteZoneTypeResponseModel,
  UpdateZoneTypeResponseModel,
  GetProductLinesResponseModel,
  DeleteProductLineResponseModel,
  UpdateProductLineResponseModel,
  AddTransportsExplosiveResponseModel,
  TransportsExplosivesMasterTypeModel,
  GetTransportsExplosivesResponseModel,
  DeleteTransportsExplosiveResponseModel,
  UpdateTransportsExplosiveResponseModel,
} from "src/app/store/models/site-master.model";

// interface for the DeleteGuidance data payload
interface DeleteGuidancePayload {
  id: string;
}
// interface for the control inventory data
export const SKIP_AUTH_INTERCEPTOR = new HttpContextToken(() => false);

@Injectable({ providedIn: "root" })
export class HttpService {
  private http = inject(HttpClient);
  private tenant = inject(TenantService);
  private storage = inject(StorageService);
  private performanceLocationCache?: PerformanceLocationResponse;

  private tenantInfo: TenantInfoModel | null = null;

  constructor() {
    this.initTenantInfo();
  }

  async initTenantInfo(): Promise<void> {
    this.tenantInfo = (await this.storage.get("tenantInfo")) as TenantInfoModel;

    if (!this.tenantInfo) {
      const user: UserModel = await this.storage.get("user");
      await this.tenant.getTenantConfiguration(user?.email!);
      this.tenantInfo = await this.storage.get("tenantInfo");
    }
  }

  private getAuthHeaders(): HttpHeaders {
    const token = this.tenantInfo?.connection?.token ?? "";
    return new HttpHeaders({ "X-APIKey": token });
  }

  GetSiteSettings = (data: { locationId: string }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.getSiteSettings, data);
  };

  GetOtp = (data: { email: string }): Observable<UserResponseModel> => {
    return this.http.post<UserResponseModel>(ApiEndPoint.getOtp, data);
  };

  GetPerformanceReportSendConfig = (): Observable<{
    status: boolean;
    data?: { sendEnabled: boolean; newThisMonth?: NewThisMonthConfig | null };
  }> => {
    return this.http.post<{
      status: boolean;
      data?: { sendEnabled: boolean; newThisMonth?: NewThisMonthConfig | null };
    }>(
      ApiEndPoint.getPerformanceReportSendConfig,
      { requested: true },
    );
  };

  GetUrlToBlob = (data: { url: string }): Observable<UserResponseModel> => {
    return this.http.post<UserResponseModel>(ApiEndPoint.urlToBlob, data);
  };

  VerifyOtp = (data: {
    otp: number;
    email: string;
    fcmToken?: FcmToken;
  }): Observable<UserResponseModel> => {
    return this.http.post<UserResponseModel>(ApiEndPoint.verifyOtp, data);
  };

  GoogleLogin = (data: {
    idToken: string;
    fcmToken?: FcmToken;
  }): Observable<UserResponseModel> => {
    return this.http.post<UserResponseModel>(ApiEndPoint.googleLogin, data);
  };

  SignOut = (data: {
    email: string;
    fcmToken?: FcmToken;
  }): Observable<SignOutResponse> => {
    return this.http.post<SignOutResponse>(ApiEndPoint.signOut, data);
  };

  getCheckInSites = (): Observable<CheckInSitesResponse> => {
    return this.http.get<CheckInSitesResponse>(ApiEndPoint.getCheckInSites);
  };

  RegisterUser = (data: { data: UserModel }): Observable<UserResponseModel> => {
    return this.http.post<UserResponseModel>(ApiEndPoint.registerUser, data);
  };

  UpdateUser = (data: UpdateUserModel): Observable<UserResponseModel> => {
    return this.http.post<UserResponseModel>(ApiEndPoint.updateUser, data);
  };
  ChangeUserRole = (
    data: ChangeRoleModel[],
  ): Observable<ChangeRoleResponseModel> => {
    return this.http.post<ChangeRoleResponseModel>(
      ApiEndPoint.changeUserRole,
      data,
    );
  };
  changeAssessmentStatus = (
    data: IChangeAssessmentStatus,
  ): Observable<IChangeAssessmentStatus> => {
    return this.http.post<IChangeAssessmentStatus>(
      ApiEndPoint.changeAssessmentStatus,
      data,
    );
  };

  ShareApp = (data: { email: string }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.shareApp, data);
  };

  GetUserCalendarLink = (data: {
    email: string;
    calendarId: string;
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.getUserCalendarLink, data);
  };

  GetSiteCalendarLink = (data: {
    email: string;
    siteId: string;
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.getSiteCalendarLink, data);
  };

  AssetsSendForApproval = (data: {
    siteId: string;
    assets: AssetModel[];
  }): Observable<AssetsResponseModel> => {
    return this.http.post<AssetsResponseModel>(
      ApiEndPoint.assetsSendForApproval,
      data,
    );
  };
  RegisterAssets = (data: {
    siteId: string;
    assets: AssetModel[];
  }): Observable<AssetsResponseModel> => {
    return this.http.post<AssetsResponseModel>(
      ApiEndPoint.registerAssets,
      data,
    );
  };

  AssetResubmitForApproval = (data: {
    siteId: string;
    asset: AssetModel;
  }): Observable<AssetRegisterResponseModel> => {
    return this.http.post<AssetRegisterResponseModel>(
      ApiEndPoint.assetResubmitForApproval,
      data,
    );
  };

  AssetRevertStatus = (data: {
    siteId: string;
    asset: AssetModel;
  }): Observable<AssetRegisterResponseModel> => {
    return this.http.post<AssetRegisterResponseModel>(
      ApiEndPoint.assetRevertStatus,
      data,
    );
  };

  AssetDecommission = (data: {
    siteId: string;
    asset: AssetModel;
  }): Observable<AssetRegisterResponseModel> => {
    return this.http.post<AssetRegisterResponseModel>(
      ApiEndPoint.assetDecommission,
      data,
    );
  };
  AssetDemolition = (data: {
    siteId: string;
    asset: AssetModel;
  }): Observable<AssetRegisterResponseModel> => {
    return this.http.post<AssetRegisterResponseModel>(
      ApiEndPoint.assetDemolition,
      data,
    );
  };

  RegisterAsset = (data: {
    siteId: string;
    asset: AssetModel;
  }): Observable<AssetRegisterResponseModel> => {
    return this.http.post<AssetRegisterResponseModel>(
      ApiEndPoint.registerAsset,
      data,
    );
  };

  RemoveDemolishedAsset = (data: {
    siteId: string;
    assets: AssetModel[];
  }): Observable<AssetDemolishedResponseModel> => {
    return this.http.post<AssetDemolishedResponseModel>(
      ApiEndPoint.removeDemolishedAsset,
      data,
    );
  };

  GetAllSites = (data?: any): Observable<SitesResponseModel> => {
    return this.http.post<SitesResponseModel>(ApiEndPoint.getAllSites, data);
  };

  SendNotification = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.sendNotification, data);
  };

  GetAllNotifications = (data?: any): Observable<NotificationResponse> => {
    return this.http.post<NotificationResponse>(
      ApiEndPoint.getAllNotifications,
      data,
    );
  };

  UpdateNotification = (data?: any): Observable<NotificationResponse> => {
    return this.http.post<NotificationResponse>(
      ApiEndPoint.updateNotifications,
      data,
    );
  };

  AddSiteFencing = (data: {
    siteId: string;
    siteCoordinatesId: string;
    siteCoordinates: { lat: number; lng: number }[];
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.addSiteFencing, data);
  };

  DeleteSiteFencing = (data: {
    siteId: string;
    siteCoordinatesId: string;
    user: UserModel;
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.deleteSiteFencing, data);
  };

  AddZoneFencingAndNames = (data: {
    siteId: string;
    zoneCoordinates: any;
    zoneName: any;
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.addZoneFencing, data);
  };

  DeleteZoneFencingAndNames = (data: {
    siteId: string;
    zoneCoordinatesId: string;
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.deleteZoneFencingAndNames, data);
  };

  GetAllAssets = (data?: any): Observable<GetAssetsResponseModel> => {
    return this.http.post<GetAssetsResponseModel>(
      ApiEndPoint.getAllAssets,
      data,
    );
  };

  GetTranslation = (data: {
    lang: string;
  }): Observable<TranslationsResponseModel> => {
    return this.http.post<TranslationsResponseModel>(
      ApiEndPoint.getTranslation,
      data,
    );
  };

  AddDraftAsset = (data: {
    siteId: string;
    asset: AssetModel;
  }): Observable<AssetResponseModel> => {
    return this.http.post<AssetResponseModel>(ApiEndPoint.addDraftAsset, data);
  };

  UpdateDraftAssets = (data: {
    siteId: string;
    assets: AssetModel[];
  }): Observable<AssetResponseModel> => {
    return this.http.post<AssetResponseModel>(
      ApiEndPoint.updateDraftAssets,
      data,
    );
  };

  RemoveDraftAssets = (data?: any): Observable<RemoveAssetsResponseModel> => {
    return this.http.post<RemoveAssetsResponseModel>(
      ApiEndPoint.removeDraftAssets,
      data,
    );
  };

  DeactivateDraftAssets = (
    data?: any,
  ): Observable<RemoveAssetsResponseModel> => {
    return this.http.post<RemoveAssetsResponseModel>(
      ApiEndPoint.deactivateDraftAssets,
      data,
    );
  };

  DeactivateDraftAsset = (
    data?: any,
  ): Observable<RemoveAssetsResponseModel> => {
    return this.http.post<RemoveAssetsResponseModel>(
      ApiEndPoint.deactivateDraftAsset,
      data,
    );
  };

  AddGuidedInspection = (data?: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.addGuidedInspection, data);
  };

  RejectAsset = (data?: any): Observable<AssetResponseModel> => {
    return this.http.post<any>(ApiEndPoint.rejectAsset, data);
  };

  ApproveAssets = (data?: any): Observable<AssetResponseModel> => {
    return this.http.post<any>(ApiEndPoint.approveAssets, data);
  };
  ApproveAsset = (data?: any): Observable<AssetResponseModel> => {
    return this.http.post<any>(ApiEndPoint.approveAsset, data);
  };

  GetGuidedInspection = (data?: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.getGuidedInspection, data);
  };
  SyncExcelToExpertApp = (data?: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.syncExcelToExpertApp, data);
  };
  RemoveGuidedInspection = (data?: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.removeGuidedInspection, data);
  };
  UpdateGuidedInspection = (data?: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.updateGuidedInspection, data);
  };
  GetAllGuidedInspection = (data?: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.getAllGuidedInspection, data);
  };
  GetGuidedInspectionDetails = (data?: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.getGuidedInspectionDetails, data);
  };
  SapConfiguration = (data?: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.sapConfiguration, data);
  };
  AssetsPendingForApproval = (data?: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.assetsPendingForApproval, data);
  };
  GetAllSapConfiguration = (): Observable<SAPConfigurationResponseModel> => {
    return this.http.get<SAPConfigurationResponseModel>(
      ApiEndPoint.getAllSapConfiguration,
    );
  };

  GetAllConnections = ({
    sourceName,
    connectionType,
    status,
  }: {
    sourceName?: string;
    connectionType?: string;
    status?: string;
  } = {}): Observable<ALLConnectionResponseModel> => {
    let params = new HttpParams();
    if (sourceName) {
      params = params.set("sourceName", sourceName);
    }
    if (connectionType) {
      params = params.set("connectionType", connectionType);
    }
    if (status === "true" || status === "false") {
      params = params.set("status", status);
    }
    return this.http.get<ALLConnectionResponseModel>(
      ApiEndPoint.getAllConnections,
      { params },
    );
  };
  GetAllMasterAsset = (data?: any): Observable<MasterAssetResponseModel> => {
    return this.http.post<MasterAssetResponseModel>(
      ApiEndPoint.getAllMasterAsset,
      data,
    );
  };
  GetERPAssetsCount = (data: {
    location: string;
    unique_id: string;
    sap_key_code: string;
  }): Observable<ERPAssetsResponseModel> => {
    return this.http.post<ERPAssetsResponseModel>(
      ApiEndPoint.getERPAssetsCount,
      data,
    );
  };
  GetAllUniqueAssetTypeFromSAPAssetMaster = (
    data?: any,
  ): Observable<GetAllUniqueAssetTypeFromSAPAssetMasterResponseModel> => {
    return this.http.post<GetAllUniqueAssetTypeFromSAPAssetMasterResponseModel>(
      ApiEndPoint.getAllUniqueAssetTypeFromSAPAssetMaster,
      data,
    );
  };
  MapSapAssetsConfiguration = (
    data?: any,
  ): Observable<MapSapAssetsConfigurationModelModel> => {
    return this.http.post<MapSapAssetsConfigurationModelModel>(
      ApiEndPoint.mapSapAssetsConfiguration,
      data,
    );
  };

  // * File
  UploadImage = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.uploadImage, data);
  };

  DeleteFile = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.deleteFile, data);
  };
  UploadFile = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.uploadFile, data);
  };
  UploadFileWithProgress = (data: any): Observable<HttpEvent<any>> => {
    return this.http.post<any>(ApiEndPoint.uploadFile, data, {
      reportProgress: true,
      observe: "events",
    });
  };
  DeleteBucketFile = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.deleteBucketFile, data);
  };
  UploadImageOnSamePath = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.uploadImageOnSamePath, data);
  };
  AssesmentCreation = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.assesmentCreation, data);
  };

  GetAllAssesment = (data: {
    locationId: string;
  }): Observable<GetAllAssessmentResponseModel> => {
    return this.http.post<GetAllAssessmentResponseModel>(
      `${ApiEndPoint.getAllAssesment}`,
      data,
    );
  };
  GetAllUsers = (data: { email: string }): Observable<UserResponseModel> => {
    return this.http.post<UserResponseModel>(
      `${ApiEndPoint.getAllUsers}`,
      data,
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  GetDefaultSAPPushUrl = (): Observable<DefaultURLResponseModel> => {
    return this.http.get<DefaultURLResponseModel>(
      ApiEndPoint.getDefaultSAPPushUrl,
    );
  };

  // !! Need to fix @MH NAHIB
  DownloadSapLogs = (data: {
    SapConfigurationId: string;
    logId: string;
  }): Observable<Blob> => {
    return this.http.post<Blob>(ApiEndPoint.downloadSapLogs, data, {
      // headers: this.headers,
      responseType: "blob" as "json",
    });
  };
  // !! Need to fix @MH NAHIB

  ValidatePullSystem = (data: {
    protocol: string;
    url: string;
    gatewayToken: string;
    token: string;
    fields?: string[];
  }): Observable<ValidatePullSystemResponseModel> => {
    return this.http.post<ValidatePullSystemResponseModel>(
      ApiEndPoint.validatePullSystem,
      data,
    );
  };

  GetAllFindings = (data: {
    siteId: string;
    assessmentId: string;
  }): Observable<FindingResponseModel> => {
    return this.http.post<any>(ApiEndPoint.getAllFindings, data);
  };

  AddFindingToiCare = (data: FindingDetails): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.addFindingToiCare}`, data);
  };
  AddFindingToMaterialManagement = (
    data: FindingDetails,
  ): Observable<FindingMaterialManagementModel> => {
    return this.http.post<FindingMaterialManagementModel>(
      `${ApiEndPoint.addFindingForMaterialManagement}`,
      data,
    );
  };
  AddNoteToFinding = (
    findingId: string,
    assessmentId: string,
    note: FindingNoteModel,
  ): Observable<FindingNotesResponseModel> => {
    const payload = {
      findingId,
      assessmentId,
      note,
    };

    return this.http.post<FindingNotesResponseModel>(
      `${ApiEndPoint.addNoteToFinding}`,
      payload,
    );
  };
  NoNewFinding = (data: {
    assetId: string;
    assessmentId: string;
  }): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.noNewFinding}`, data);
  };

  ReassignAction = (data: {
    actionId: string;
    findingId: string;
    assessmentId: string;
    reassignedTo: {
      email: string;
      firstName: string;
      lastName: string;
    };
  }): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.reassignAction}`, data);
  };

  // deleteFinding
  DeleteFinding = (data: {
    findingId: string;
    assessmentId: string;
  }): Observable<ApiResponseModel> => {
    return this.http.post<ApiResponseModel>(ApiEndPoint.deleteFinding, data);
  };

  // deleteAction
  DeleteAction = (data: {
    findingId: string;
    actionId: string;
    assessmentId: string;
  }): Observable<ApiResponseModel> => {
    return this.http.post<ApiResponseModel>(ApiEndPoint.deleteAction, data);
  };

  GetDashboard = (data: {
    locationId: string;
  }): Observable<DashboardResponseModel> => {
    return this.http.post<DashboardResponseModel>(
      `${ApiEndPoint.getDashboard}`,
      data,
    );
  };
  GetAllCache = (): Observable<any> => {
    return this.http.get<any>(ApiEndPoint.getAllCache);
  };
  GetAllEiCache = (): Observable<any> => {
    return this.http.get<any>(ApiEndPoint.getAllEiCache);
  };
  GetAssetMappingCache = (): Observable<any> => {
    return this.http.get<any>(ApiEndPoint.getAssetMappingCache);
  };
  GetAllUsersCache = (): Observable<any> => {
    return this.http.get<any>(ApiEndPoint.getAllUsersCache);
  };
  GetAllUsersForACountry = (data: { countryId: string }): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.getAllUsersForACountry}`, data);
  };
  GetDashboardCalendar = (data: {
    start: string;
    end: string;
  }): Observable<FullCalendarResponseModel> => {
    return this.http.post<FullCalendarResponseModel>(
      `${ApiEndPoint.getDashboardCalendar}`,
      data,
    );
  };
  getAssessmentsForCountriesSite = (data: {
    countryId: string;
  }): Observable<any> => {
    return this.http.post<any>(
      ApiEndPoint.getAssessmentsForCountriesSite,
      data,
    );
  };

  sendEmailToPerfEditor(data: any): Observable<any> {
    return this.http.post<any>(`${ApiEndPoint.sendEmailToPerfEditor}`, data);
  }

  sendPerformanceEmailReportMail(data: any): Observable<any> {
    return this.http.post<any>(`${ApiEndPoint.sendPerfEmailReportMail}`, data);
  }

  submitPerformanceTabCompletion(payload: {
    tab_key: string;
    month: string;
    user_meta: { role?: string; profile_image?: string };
  }): Observable<any> {
    return this.http.post<any>(
      ApiEndPoint.submitPerformanceTabCompletion,
      payload,
    );
  }

  getPerformanceReportingDate(): Observable<ReportingDateResponse> {
    return this.http.get<ReportingDateResponse>(
      `${ApiEndPoint.getReportingDate}`,
      {
        headers: this.getAuthHeaders(),
        context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
      },
    );
  }

  postPerformanceReportingDateReport(data: {
    admin: boolean;
  }): Observable<ReportingDateResponse> {
    return this.http.post<ReportingDateResponse>(
      `${ApiEndPoint.postReportingDate}`,
      { data },
      {
        headers: this.getAuthHeaders(),
        context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
      },
    );
  }

  TestConnectionForAWSSQS = (data: {
    url: string;
    accessKey: string;
    secretKey: string;
  }): Observable<TestConnectionForAWSSQSResponseModel> => {
    return this.http.post<TestConnectionForAWSSQSResponseModel>(
      `${ApiEndPoint.testConnectionForAWSSQS}`,
      data,
    );
  };

  TestConnectionForAWSCognito = (data: {
    url: string;
    username: string;
    password: string;
  }): Observable<TestConnectionForAWSCognitoResponseModel> => {
    return this.http.post<TestConnectionForAWSCognitoResponseModel>(
      `${ApiEndPoint.testConnectionForAmazonCognito}`,
      data,
    );
  };
  TestConnectionForSAPNotification = (data: {
    url: string;
    username: string;
    password: string;
    notificationUrl: string;
    notificationClientId: string;
    notificationClientSecret: string;
  }): Observable<TestConnectionForSAPNotificationResponseModel> => {
    return this.http.post<TestConnectionForSAPNotificationResponseModel>(
      `${ApiEndPoint.testConnectionCreateNotificationOnSAP}`,
      data,
    );
  };

  ConnectionSetupForAssetInventory = (
    data: ConnectionModel & { stepNumber?: number },
  ): Observable<ConnectionResponseModel> => {
    return this.http.post<ConnectionResponseModel>(
      `${ApiEndPoint.connectionSetupForAssetInventory}`,
      data,
    );
  };
  ConnectionSetupForNotificationCreation = (
    data: ConnectionModel & { stepNumber?: number },
  ): Observable<ConnectionResponseModel> => {
    return this.http.post<ConnectionResponseModel>(
      `${ApiEndPoint.connectionSetupForCreateNotification}`,
      data,
    );
  };

  // return this.http.get<ActiveGruResponse>(`${ApiEndPoint.getAllActiveGru}`, {
  //   headers: this.getAuthHeaders(),
  // });

  GetAssetList = (): Observable<AssetListResponseModel> => {
    return this.http.get<AssetListResponseModel>(
      `${ApiEndPoint.getAssetList}`,
      // {
      //   headers: this.getAuthHeaders(),
      // },
    );
  };

  GetConnectionAssetsConfiguration = (
    data: ConnectionAssetConfigurationModel,
  ): Observable<ConnectionAssetConfigurationResponseModel> => {
    return this.http.post<ConnectionAssetConfigurationResponseModel>(
      ApiEndPoint.getConnectionAssetsConfiguration,
      data,
    );
  };

  UpdateAssetConfiguration = (
    connectionId: string,
    data: AssetConfigurationMappingModel[],
    hacCodeEnabled: boolean,
  ): Observable<ConnectionAssetConfigurationResponseModel> => {
    return this.http.post<ConnectionAssetConfigurationResponseModel>(
      ApiEndPoint.updateAssetConfiguration,
      {
        connectionId,
        data,
        hacCodeEnabled,
      },
    );
  };

  CloseFinding = (data: {
    assessmentId: string;
    findingId: string;
    closure: {
      dateClosed: string;
      closedBy: {
        email: string;
        firstName: string;
        lastName: string;
      };
      completionComments: string;
      closedAttachment: FileModel[];
    };
    actCost: {
      opex: number;
      total: number;
      capex: number;
    };
  }): Observable<FindingResponseModel> => {
    return this.http.post<FindingResponseModel>(
      `${ApiEndPoint.closeFinding}`,
      data,
    );
  };

  CloseAction = (data: {
    assessmentId: string;
    actionId: string;
    closure: {
      dateClosed: string;
      closedBy: {
        email: string;
        firstName: string;
        lastName: string;
      };
      completionComments: string;
      closedAttachment: FileModel[];
    };
  }): Observable<ActionResponseModel> => {
    return this.http.post<ActionResponseModel>(
      `${ApiEndPoint.closeAction}`,
      data,
    );
  };

  // ** BOG API'S
  // * BoG Plants
  GetAllNearestSites = (
    lat: number,
    long: number,
    email: string,
  ): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.getAllNearestSites}`,
      {
        data: {
          latitude: lat,
          longitude: long,
          email: email,
        },
      },
      { headers: this.getAuthHeaders() },
    );
  };

  // * Gru
  GetAllActiveGru = (): Observable<ActiveGruResponse> => {
    return this.http.get<ActiveGruResponse>(`${ApiEndPoint.getAllActiveGru}`, {
      headers: this.getAuthHeaders(),
    });
  };
  // * Unit
  GetAllUnitsWithinLevels = (data: any): Observable<ActiveUitResponse> => {
    return this.http.post<ActiveUitResponse>(
      ApiEndPoint.getAllUnitsWithinLevels,
      data,
      { headers: this.getAuthHeaders() },
    );
  };

  // * Bog Site
  GetAllSitesWithinLevels = (data: any): Observable<ActiveSiteResponse> => {
    return this.http.post<ActiveSiteResponse>(
      ApiEndPoint.getAllPlantsWithinLevels,
      data,
      { headers: this.getAuthHeaders() },
    );
  };

  //* Bog QR  */
  GetQRFromSiteByIdBogPro = (data: { uniqueId: string }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.getQRFromSiteByIdBogPro, data, {
      headers: this.getAuthHeaders(),
    });
  };

  SaveOrUpdateQrBogPro = (data: {
    siteUniqueId: string;
    qrId: string;
    latLong: string;
    createdBy: string;
    plant: string;
    zone: string;
    qrValue?: {};
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.saveOrUpdateQrBogPro, data, {
      headers: this.getAuthHeaders(),
    });
  };

  DeleteQrBogPro = (data: {
    siteUniqueId: string;
    qrId: string;
    user: string;
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.deleteQrBogPro, data, {
      headers: this.getAuthHeaders(),
    });
  };

  GetKeylessonsPuesBogPro = (): Observable<any> => {
    return this.http.get<any>(ApiEndPoint.getKeylessonsPuesBogPro, {
      headers: this.getAuthHeaders(),
    });
  };

  GetKeylessonsPpesBogPro = (): Observable<any> => {
    return this.http.get<any>(ApiEndPoint.getKeylessonsPpesBogPro, {
      headers: this.getAuthHeaders(),
    });
  };

  GetLocalCurrencyBogPro = (data: {
    siteId: string;
  }): Observable<CurrencyInformationResponseModel> => {
    return this.http.post<CurrencyInformationResponseModel>(
      ApiEndPoint.getLocalCurrencyBogPro,
      data,
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  GetUserDetail = (data: { email: string }): Observable<UserResponseModel> => {
    return this.http.post<UserResponseModel>(
      `${ApiEndPoint.getUserDetail}`,
      data,
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  // * Get BOG WhoIsWho
  GetWhoIsWho = (data: {
    data: {
      plant_unique_id: string;
    };
  }): Observable<whoIsWhoResponseModel> => {
    return this.http.post<whoIsWhoResponseModel>(
      ApiEndPoint.getWhoIsWho,
      data,
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  // * Get BOG Housekeeping stats for a site
  GetHouseKeepingStats = (data: {
    data: {
      plant_unique_id: string;
    };
  }): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.getHousekeepingStatsForGRU}`,
      data,
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  // * Get BOG Housekeeping comments for a site
  GetHousekeepingCommentsForSite = (data: {
    data: {
      plant_id: string;
    };
  }): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.getHousekeepingCommentsForSite}`,
      data,
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  // * Get RandR Data
  GetRandRData = (data: { data: { plant_id: string } }): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.getRandRData}`, data, {
      headers: this.getAuthHeaders(),
    });
  };

  // * We Talk (VPC + CVPC) / I See (HAZ) per BOG site id in a month (Mapping site view)
  GetSiteObservationCounts = (data: {
    data: { plant_ids: string[]; date: string };
  }): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.getSiteObservationCounts}`, data, {
      headers: this.getAuthHeaders(),
    });
  };

  // * Get Rapid tour data
  GetRapidTourData = (data: {
    data: { plant_id: string; email: string };
  }): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.getRapidTourData}`, data, {
      headers: this.getAuthHeaders(),
    });
  };

  // * Get Configure Site (zone creation) BoG
  ConfigureZone = (data: {
    siteName: string;
    siteUniqueId: string;
    savePolygon: {
      coordinates: {
        lat: number;
        lng: number;
      }[];
    }[];
  }): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.configureSite}`, data, {
      headers: this.getAuthHeaders(),
    });
  };

  // Zone completion status toggle
  ToggleZoneStatus = (data: {
    siteId: string;
    zoneId: string;
  }): Observable<SiteModel> => {
    return this.http.post<SiteModel>(ApiEndPoint.toggleZoneStatus, data);
  };

  // * Get segment masters from BoG
  GetSegmentsMasterBogPro = (): Observable<any> => {
    return this.http.get<any>(ApiEndPoint.getSegmentsMasterBogPro, {
      headers: this.getAuthHeaders(),
    });
  };

  // * Get configure site zoneName BoG
  ConfigureSiteZoneName = (data: {
    zoneName: string;
    category: string;
    costCenter: string;
    id: string;
    user: string;
    siteUniqueId: string;
  }): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.configureSiteZoneName}`, data, {
      headers: this.getAuthHeaders(),
    });
  };
  // * Get configure site zoneName BoG
  ConfigureSiteFencing = (data: {
    uniqueSiteId: string;
    id?: string;
    siteCoordinates: {
      lat: number;
      lng: number;
    }[];
  }): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.configureSiteFencing}`, data, {
      headers: this.getAuthHeaders(),
    });
  };

  GetAllLocationsByLevel = (
    data: any,
  ): Observable<LocationsByLevelResponse> => {
    return this.http.post<LocationsByLevelResponse>(
      ApiEndPoint.getAllPlantsWithinLevels,
      data,
      { headers: this.getAuthHeaders() },
    );
  };

  //Energy isolation
  GetEICountry = (): Observable<EICountryModelResponse> => {
    return this.http.get<EICountryModelResponse>(ApiEndPoint.getEICountry);
  };
  GetEISitesByCountry = (
    data: any,
  ): Observable<EISitesByCountryModelResponse> => {
    return this.http.post<EISitesByCountryModelResponse>(
      ApiEndPoint.getEISitesByCountry,
      data,
    );
  };
  GetLocationCategory = (
    data: any,
  ): Observable<LocationCategoryModelResponse> => {
    return this.http.post<LocationCategoryModelResponse>(
      ApiEndPoint.getLocationCategory,
      data,
    );
  };

  GetActivities = (data: any): Observable<ActivitiesModelResponse> => {
    return this.http.post<ActivitiesModelResponse>(
      ApiEndPoint.getActivities,
      data,
    );
  };

  GetEIUsers = (data: any): Observable<EIUserModelResponse> => {
    return this.http.post<EIUserModelResponse>(ApiEndPoint.getEIUsers, data);
  };

  GetEIUsersListByRole = (data: any): Observable<EIUserModelResponse> => {
    return this.http.post<EIUserModelResponse>(
      ApiEndPoint.getEIUserListByRole,
      data,
    );
  };

  GetEIMyAssignRoles = (data: {
    email: string;
  }): Observable<EIMyAssignRoleResponse> => {
    return this.http.post<EIMyAssignRoleResponse>(
      ApiEndPoint.getUserAssignRoles,
      data,
    );
  };

  GetEIStepNo = (): Observable<EIStepNoModelResponse> => {
    return this.http.get<EIStepNoModelResponse>(ApiEndPoint.getEIStepNo);
  };

  GetEIEnergyTypes = (data: any): Observable<EIEnergyTypesModelResponse> => {
    return this.http.post<EIEnergyTypesModelResponse>(
      ApiEndPoint.getEIEnergyTypes,
      data,
    );
  };
  SaveEneryProcedure = (
    data: EnergryIsolationProcedureAPIDataModel,
  ): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.postEnergyIsolationProcedure}`, {
      data: data,
    });
  };

  GetEIProcedure = (data: any): Observable<EiProceduresResponse> => {
    return this.http.post<EiProceduresResponse>(
      ApiEndPoint.getEnergyIsolationProcedure,
      data,
    );
  };

  UpdateEIProcedure = (data: any): Observable<UpdateEiProceduresResponse> => {
    return this.http.post<UpdateEiProceduresResponse>(
      ApiEndPoint.updateEnergyIsolationProcedure,
      data,
    );
  };
  CreateNewVersionProcedure = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.createNewVersionProcedure, data);
  };
  DeleteEIProcedure = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.deleteEIProcedure, data);
  };

  DeleteEIUser = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.deleteEIUser, data);
  };

  AddEIUser = (data: any): Observable<AddEIUserResponse> => {
    return this.http.post<AddEIUserResponse>(ApiEndPoint.addEIUser, data);
  };
  UpdateEIUser = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.updateEIUser, data);
  };
  UpdateEIAuthorChange = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.updateEIUserChange, data);
  };
  GetBusinessSegmentBySite = (
    data: any,
  ): Observable<BusinessSegmentBySiteResponse> => {
    return this.http.post<BusinessSegmentBySiteResponse>(
      ApiEndPoint.getBusinessSegmentBySite,
      data,
    );
  };
  BulkApprovalEIProcedure = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.bulkApprovalEIProcedure, data);
  };
  GetIsolationDeviceType = (
    data: any,
  ): Observable<IsolationDeviceTypeResponse> => {
    return this.http.post<IsolationDeviceTypeResponse>(
      ApiEndPoint.getIsolationDeviceType,
      data,
    );
  };
  GetLanguage = (): Observable<any> => {
    return this.http.post<{ data: string }>(ApiEndPoint.getEILanguage, {
      data: "Language",
    });
  };
  UpdateAssessmentStatus = (data: {
    id: string;
    assetId: string;
    isAssessmentCompleted: boolean;
  }): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.updateAssessmentStatus}`, data);
  };
  UpdateMaterialAssessmentStatus = (data: {
    id: string;
    assetId: string;
    isAssessmentCompleted: boolean;
  }): Observable<UpdateMaterialAssessmentStatusResponseModel> => {
    return this.http.post<UpdateMaterialAssessmentStatusResponseModel>(
      `${ApiEndPoint.updateMaterialAssessmentStatus}`,
      data,
    );
  };

  UpdateSiteInfo = (data: {
    siteId: string;
    site_latLong?: string;
    sap_key_code?: string;
    siteCoordinatesId: string;
    siteFencingInfo: SiteInfoModel;
    securityRepresentative?: UserModel | null;
    businessResilienceCoordinator?: UserModel | null;
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.updateSiteInfo, data);
  };

  // UpdateSiteInformation = (data: {
  //   uniqueSiteId: string;
  //   info: {
  //     year_of_construction?: string;
  //     emergency_contact_details?: {
  //       emergency_number?: string;
  //       local_firefighters?: string;
  //       hospital_address?: string;
  //     };
  //     site_imgs?: {
  //       src?: string;
  //       id?: string;
  //       fileType?: string;
  //     }[];
  //     unitManager?: { email?: string; firstName?: string; lastName?: string };
  //     countryHSEHead?: {
  //       email?: string;
  //       firstName?: string;
  //       lastName?: string;
  //     };
  //     inventoryCreator?: {
  //       email?: string;
  //       firstName?: string;
  //       lastName?: string;
  //     }[];
  //   };
  // }): Observable<{ status: boolean; message: string; data: SiteModel }> => {
  //   return this.http.post<{
  //     status: boolean;
  //     message: string;
  //     data: SiteModel;
  //   }>(`${ApiEndPoint.updatePlantInformation}`, data, {
  //     headers: this.getAuthHeaders(),
  //   });
  // };

  UploadEIUserData = (data: any): Observable<EiAddUpdateApiResponse> => {
    return this.http.post<EiAddUpdateApiResponse>(
      ApiEndPoint.uploadEIUserData,
      data,
    );
  };

  GetGadEmployeesFromBog = (
    data: any,
  ): Observable<GetGadEmployeesFromBogResponse> => {
    return this.http.post<GetGadEmployeesFromBogResponse>(
      `${ApiEndPoint.getGadEmployees}`,
      data,
      {
        headers: this.getAuthHeaders(),
      },
    );

    // this.http.post<GetGadEmployeesFromBogResponse>(
    //   ApiEndPoint.getGadEmployees,
    //   data,
    //   { headers: this.getAuthHeaders() },
    // );
  };

  UpdateEILanguageInUsers = (
    data: EIUserLanguageModel,
  ): Observable<EIUserLanguageModel> => {
    return this.http.post<EIUserLanguageModel>(
      ApiEndPoint.updateEISelectedLanguage,
      data,
    );
  };
  UpdateEILanguage = (data: EILanguageUpdate): Observable<EILanguageUpdate> => {
    return this.http.post<EILanguageUpdate>(ApiEndPoint.updateEILanguage, data);
  };

  GetFilterRegionCountrySite = (): Observable<any> => {
    return this.http.get<any>(ApiEndPoint.getFilterRegionCountrySite);
  };
  GetCountProcedure = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.getCountProcedure, data);
  };

  GetAllConnectionLogs = (data: {
    connectionId: string;
    yearMonth?: string;
  }): Observable<LogsResponseModel> => {
    return this.http.post<LogsResponseModel>(
      ApiEndPoint.getConnectionLogs,
      data,
    );
  };
  ConnectionActivation = (data: {
    connectionId: string;
  }): Observable<ConnectionResponseModel> => {
    return this.http.post<ConnectionResponseModel>(
      ApiEndPoint.connectionActivation,
      data,
    );
  };

  UploadPMCodeConfigurationInExcel = (data: {
    connectionId: string;
    data: {
      file: string;
    };
  }): Observable<UploadedXlsxConfigurationResponseModel> => {
    return this.http.post<UploadedXlsxConfigurationResponseModel>(
      ApiEndPoint.uploadPMCodeConfigurationInExcel,
      data,
    );
  };
  GetLoggedInUserEIProcedureList = (data: any): Observable<any> => {
    return this.http.post<any>(
      ApiEndPoint.getLoggedInUserEIProcedureList,
      data,
    );
  };
  GetAllGuidance = (): Observable<any> => {
    return this.http.get<any>(`${ApiEndPoint.getAllGuidance}`);
  };
  AddGuidance = (data: Guidance): Observable<AddGuidanceResponse> => {
    return this.http.post<AddGuidanceResponse>(ApiEndPoint.addGuidance, {
      data: data,
    });
  };
  AddDefects = (data: Guidance): Observable<AddGuidanceResponse> => {
    return this.http.post<AddGuidanceResponse>(ApiEndPoint.addDefects, {
      data: data,
    });
  };

  GetGuidanceDetailsById = (id: string): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.getGuidanceDetailsById}`, {
      id: id,
    });
  };

  BogPro_DeleteGuidance = (
    data: DeleteGuidancePayload,
  ): Observable<DeleteGuidanceResponse> => {
    return this.http.post<any>(ApiEndPoint.deleteGuidance, data);
  };
  BogPro_DeleteDefects = (
    data: DeleteGuidancePayload,
  ): Observable<DeleteGuidanceResponse> => {
    return this.http.post<any>(ApiEndPoint.deleteDefect, data);
  };

  GetGlobalMMInventory = (data: {
    siteId: string;
  }): Observable<MM_InventoryListResponseModel> => {
    return this.http.post<MM_InventoryListResponseModel>(
      ApiEndPoint.getGlobalMMInventory,
      data,
    );
  };

  GetMMInventoryListBySideId = (data: {
    siteId: string;
  }): Observable<MM_InventoryListResponseModel> => {
    return this.http.post<MM_InventoryListResponseModel>(
      ApiEndPoint.getMMInventoryListBySiteId,
      data,
    );
  };
  GetMMMaterialType = (): Observable<MM_MaterialTypesResponseModel> => {
    return this.http.get<MM_MaterialTypesResponseModel>(
      ApiEndPoint.getMaterialTypes,
    );
  };

  GetMMMaterialHazards = (): Observable<MM_HazardsResponseModel> => {
    return this.http.get<MM_HazardsResponseModel>(
      ApiEndPoint.getMaterialHazards,
    );
  };

  AddMMInventoryItem = (
    data: MM_InventoryModel,
  ): Observable<MM_InventoryListResponseModel> => {
    return this.http.post<MM_InventoryListResponseModel>(
      ApiEndPoint.addMMInventory,
      { data },
    );
  };

  DownloadReportsBogPro = (data: any): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.downloadReportsBogPro}`, data, {
      headers: this.getAuthHeaders(),
    });
  };

  SaveReportTemplateBogPro = (data: any): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.saveReportTemplateBogPro}`,
      data,
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  SendReportToMailBogPro = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.sendReportToMailBogPro, data, {
      headers: this.getAuthHeaders(),
    });
  };

  GetBogSingleUserBogPro = (data: any): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.getBogSingleUserBogPro}`, data, {
      headers: this.getAuthHeaders(),
    });
  };
  GetHSEDashboardMetrics = (data: {
    location: { value: string; type: string };
    date: string;
    metrics?: string[];
  }): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.getHSEDashboardMetrics}`, data, {
      headers: this.getAuthHeaders(),
      context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
    });
  };
  getCountryExcellenceAwardsData = (data: {
    filters: {
      country: string;
      date: string;
    };
  }): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.getHseCountryRecognition}`,
      { data },
      {
        headers: this.getAuthHeaders(),
        context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
      },
    );
  };

  getUnitExcellenceAwardsData = (data: {
    filters: {
      unit: string;
      date: string;
    };
  }): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.getHseUnitRecognition}`,
      { data },
      {
        headers: this.getAuthHeaders(),
        context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
      },
    );
  };

  GetReportTemplateBogPro = (): Observable<any> => {
    return this.http.get<any>(`${ApiEndPoint.getReportTemplateBogPro}`, {
      headers: this.getAuthHeaders(),
      context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
    });
  };
  GetAllRegion = (): Observable<ApiResponse> => {
    return this.http.get<ApiResponse>(ApiEndPoint.getAllRegion, {
      headers: this.getAuthHeaders(),
    });
  };
  GetAllDepartment = (): Observable<ApiResponse> => {
    return this.http.get<ApiResponse>(ApiEndPoint.getAllDepartment, {
      headers: this.getAuthHeaders(),
    });
  };

  CreateAnUser = (data: BogUserModel): Observable<ApiResponse> => {
    return this.http.post<ApiResponse>(ApiEndPoint.createAnUser, data, {
      headers: this.getAuthHeaders(),
    });
  };

  GetIcareLocation = (data: {
    data: { gru_name: string };
  }): Observable<ApiResponse> => {
    return this.http.post<ApiResponse>(ApiEndPoint.getIcareLocation, data, {
      headers: this.getAuthHeaders(),
    });
  };

  GetAllUserProfile = (): Observable<ApiResponse> => {
    return this.http.get<ApiResponse>(ApiEndPoint.getAllUserProfile, {
      headers: this.getAuthHeaders(),
    });
  };

  GetSingleUserBogPro = (
    data: BogUserModel,
  ): Observable<{ data: BogUserModel }> => {
    return this.http.post<{ data: BogUserModel }>(
      ApiEndPoint.getSingleUserBogPro,
      data,
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  GetSingleUser = (email: string): Observable<UserResponseModel> => {
    return this.http.post<UserResponseModel>(`${ApiEndPoint.getSingleUser}`, {
      email: email,
    });
  };

  UpdateSingleUserBogPro = (
    data: BogUserModel,
  ): Observable<UserResponseModel> => {
    return this.http.post<UserResponseModel>(
      `${ApiEndPoint.updateSingleUserBogPro}`,
      data,
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  UpdateSingleUser = (
    data: UpdateSingleUserModel,
  ): Observable<UserResponseModel> => {
    return this.http.post<UserResponseModel>(
      ApiEndPoint.updateSingleUser,
      data,
    );
  };
  //AdminRoles
  AddAdminRole = (
    data: Partial<IAdminRoleData>,
  ): Observable<IGetAdminRoleResponse> => {
    return this.http.post<IGetAdminRoleResponse>(
      ApiEndPoint.addAdminRole,
      data,
    );
  };
  UpdateAdminRole = (data: {
    data: Partial<IAdminRoleData>;
  }): Observable<IGetAdminRoleResponse> => {
    return this.http.post<IGetAdminRoleResponse>(
      ApiEndPoint.updateAdminRole,
      data,
    );
  };
  UpdateAdminRoleInBog = (
    data: Partial<IAdminRoleData>,
  ): Observable<IGetAdminRoleResponse> => {
    return this.http.post<IGetAdminRoleResponse>(
      `${ApiEndPoint.updateAdminRoleInBog}`,
      data,
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  SaveMMControlInventory = (
    requestBody: MM_ControlInventoryModel,
  ): Observable<IGetAdminRoleResponse> => {
    return this.http.post<IGetAdminRoleResponse>(
      ApiEndPoint.saveMMControlInventory,
      requestBody, // Now sending the correctly structured object
    );
  };
  GetMMControlInventoryList = (): Observable<ApiResponse> => {
    return this.http.get<ApiResponse>(ApiEndPoint.getMMControlInventoryList, {
      headers: this.getAuthHeaders(),
    });
  };

  deleteMMControlInventory = (id: string): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.deleteMMControlInventory, { id });
  };

  DeleteMaterial = (id: string): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.deleteMaterial, { id });
  };

  GetAllBogProUsers(data: {
    country: string[];
    sites: string[];
  }): Observable<GetAllBogProUsersResponseModel> {
    return this.http.post<GetAllBogProUsersResponseModel>(
      ApiEndPoint.getAllBogProUsers,
      data,
    );
  }

  GetCountryFromRegionCollection = (): Observable<ApiResponse> => {
    return this.http.get<ApiResponse>(
      ApiEndPoint.getCountryFromRegionCollectionBogPro,
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  GetOpcoByCountryFromRegionCollection = (data: {
    data: {
      countryId: string;
    };
  }): Observable<ApiResponse> => {
    return this.http.post<ApiResponse>(
      ApiEndPoint.getOpcoByCountryFromRegionCollectionBogPro,
      data,
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  GetAllOpcoFromRegionCollection = (): Observable<ApiResponse> => {
    return this.http.get<ApiResponse>(
      ApiEndPoint.getAllOpcoFromRegionCollectionBogPro,
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  GetBogRegion = (): Observable<ApiResponse> => {
    return this.http.get<ApiResponse>(ApiEndPoint.getBogRegion, {
      headers: this.getAuthHeaders(),
    });
  };

  GetAllBogRegionGroups = (): Observable<ApiResponse> => {
    return this.http.get<ApiResponse>(ApiEndPoint.getAllBogRegionGroups, {
      headers: this.getAuthHeaders(),
    });
  };

  AddUpdateRoleMaster = (role: {
    role: Partial<RoleMasterModel>;
  }): Observable<AddUpdateRoleMasterResponse> => {
    return this.http.post<AddUpdateRoleMasterResponse>(
      ApiEndPoint.addRole,
      role,
    );
  };
  CheckExistingGuidance = (payload: {
    assetType: string;
    materialType: string;
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.checkExistingGuidance, payload);
  };

  GetCustomerConfig = (): Observable<any> => {
    return this.http.get<any>(ApiEndPoint.getCustomerConfig, {
      headers: this.getAuthHeaders(),
    });
  };

  GetOrganisationDetails = (data: string): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.getOrganisationDetails}`,
      {
        domain: data,
      },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  GetAllUsersShieldUser = (): Observable<any> => {
    return this.http.get<any>(ApiEndPoint.getAllUsersShieldUser, {
      headers: this.getAuthHeaders(),
    });
  };
  GetAllRegionsOnly = (): Observable<any> => {
    return this.http.get<any>(ApiEndPoint.getAllRegionsOnly, {
      headers: this.getAuthHeaders(),
    });
  };
  GetRegionFromIcare = (): Observable<any> => {
    return this.http.get<any>(ApiEndPoint.getRegionFromIcare, {
      headers: this.getAuthHeaders(),
    });
  };
  SaveLocationHierarchyData = (data: any): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.saveLocationHierarchyData}`,
      {
        data: data,
      },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  GetCountryByRegionId = (regionId: string): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.getCountryByRegionId}`,
      {
        regionId: regionId,
      },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  GetCountryByRegionIdFromIcare = (regionId: string): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.getCountryByRegionIdFromIcare}`,
      {
        regionId: regionId,
      },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  FindPersonFromIcarePersonMaster = (person: any): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.findPersonFromIcarePersonMaster}`,
      {
        personId: person,
      },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  GetPlantInfoByIcarePlantNameFromRegion = (
    regionId: string,
    countryId: string,
    opcoId: string,
    plantId: string,
  ): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.getPlantInfoByIcarePlantNameFromRegion}`,
      {
        regionId: regionId,
        countryId: countryId,
        opcoId: opcoId,
        plantId: plantId,
      },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  GetPlantsByUnitIdFromIcare = (
    region: any,
    country: any,
    unitId: string,
    opcoName: string,
  ): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.getPlantsByUnitIdFromIcare}`,
      {
        region: region,
        country: country,
        unitId: unitId,
        opcoName: opcoName,
      },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  GetUnitByOpcoNameFromIcare = (
    countryId: string,
    opcoName: string,
  ): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.getUnitByOpcoNameFromIcare}`,
      {
        countryId: countryId,
        opcoName: opcoName,
      },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  UpdateOrganisationDetails = (
    organisation: any,
    organisationData: any,
  ): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.updateOrganisationDetails}`,
      {
        organisationId: organisation,
        organisationData: organisationData,
      },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  GetAllDepartments = (): Observable<any> => {
    return this.http.get<any>(ApiEndPoint.getAllDepartments, {
      headers: this.getAuthHeaders(),
    });
  };
  GetPlantById = (
    regionId: string,
    countryId: string,
    opcoId: string,
    plantId: string,
  ): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.getPlantById}`,
      {
        regionId: regionId,
        countryId: countryId,
        opcoId: opcoId,
        plantId: plantId,
      },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  GetPlantByOpcoId = (
    regionId: string,
    countryId: string,
    opcoId: string,
  ): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.getPlantByOpcoId}`,
      {
        regionId: regionId,
        countryId: countryId,
        opcoId: opcoId,
      },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  GetOpcoByCountryIdFromIcare = (countryId: string): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.getOpcoByCountryIdFromIcare}`,
      {
        countryId: countryId,
      },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  GetOpcoByCountryId = (
    regionId: string,
    countryId: string,
  ): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.getOpcoByCountryId}`,
      {
        regionId: regionId,
        countryId: countryId,
      },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  UpdateMMInventory = (
    data: Update_MM_InventoryBodyDataModel,
  ): Observable<Update_MM_InventoryResponseModel> => {
    return this.http.post<Update_MM_InventoryResponseModel>(
      ApiEndPoint.updateMMInventory,
      data,
    );
  };

  UpdateRiskLevelRequestByExpert = (data: {
    id: string;
    requestStatus: string;
    rejectionReason?: string;
  }): Observable<any> => {
    return this.http.post<any>(
      ApiEndPoint.updateRiskLevelRequestByExpert,
      data,
    );
  };

  MM_SafetySheetToExtractData = (base64pdf: string): Observable<string> => {
    return this.http.post<string>(ApiEndPoint.MM_safetySheetToExtractData, {
      base64pdf,
    });
  };
  EiProcedureReport = (
    data: Record<string, string | number | boolean | null>,
  ): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.eiProcedureReport, data);
  };

  fetchPerformanceHighLightsAndLowLights = (payload: {
    message: string;
    userEmail: string;
  }) => {
    return this.http.post<any>(
      ApiEndPoint.fetchPerformanceHighLightsAndLowLights,
      payload,
    );
  };
  pushPerformanceDataToBogStagingDB = (payload: PerformanceData) => {
    return this.http.post<any>(ApiEndPoint.createHighLowLightBogPro, payload, {
      headers: this.getAuthHeaders(),
    });
  };

  CreateMMInventoryControlSheetPdf = (
    data: MM_ControlSheetToPdfDataModel,
  ): Observable<MM_ControlSheetToPdfResponseModel> => {
    return this.http.post<MM_ControlSheetToPdfResponseModel>(
      ApiEndPoint.mm_ControlSheetToPdf,
      { data },
    );
  };

  SendMailForEiReport = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.sendMailForEiReport, data);
  };

  GenerateIntroductionForMMControlSheet = (
    materialName: string,
  ): Observable<MM_ControlSheetIntroResponseModel> => {
    return this.http.post<MM_ControlSheetIntroResponseModel>(
      ApiEndPoint.generateMMControlSheetIntroductionByGemini,
      { materialName: materialName },
    );
  };

  addCriticalIncidentPolished(payload: { data: CriticalIncidentPolished[] }) {
    return this.http.post<any>(
      `${ApiEndPoint.addCriticalIncidentPolished}`,
      payload,
      {
        headers: this.getAuthHeaders(),
      },
    );
  }

  addSinglePolishedIncident(payload: { data: CriticalIncidentPolished }) {
    return this.http.post<any>(
      `${ApiEndPoint.addSinglePolishedIncident}`,
      payload,
      {
        headers: this.getAuthHeaders(),
      },
    );
  }
  getCriticalIncident(date: any): Observable<PerformanceIncidentCiLogResponse> {
    return this.http.post<PerformanceIncidentCiLogResponse>(
      `${ApiEndPoint.getIncidentCiLogBogPro}`,
      date,
      {
        headers: this.getAuthHeaders(),
      },
    );
  }

  criticalIncidentPerformance(reqObj: PerformancePolishTextReq) {
    return this.http.post<PerformancePolishTextResp>(
      ApiEndPoint.fetchCriticalIncidentPerformance,
      reqObj,
    );
  }
  recallCriticalIncidents(reqObj: RecallRequest): Observable<RecallResponse> {
    return this.http.post<RecallResponse>(
      ApiEndPoint.recallCriticalIncidents,
      reqObj,
      {
        headers: this.getAuthHeaders(),
        context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
      },
    );
  }
  getCriticalIncidentPolished(reqObj: unknown) {
    return this.http.post<any>(
      ApiEndPoint.getCriticalIncidentPolished,
      reqObj,
      {
        headers: this.getAuthHeaders(),
        context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
      },
    );
  }

  getCountryFlagsKey() {
    return this.http.get<any>(ApiEndPoint.getCountryFlagKeynames, {
      headers: this.getAuthHeaders(),
      context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
    });
  }

  fetchHighLowScore(
    reqObj: highlowScoreRequest,
  ): Observable<HighLowScoreResponse> {
    return this.http.post<HighLowScoreResponse>(
      ApiEndPoint.getHighLowLightScore,
      reqObj,
      {
        headers: this.getAuthHeaders(),
        context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
      },
    );
  }

  generatePerformanceGraph(graphs: any) {
    return this.http.post<any>(ApiEndPoint.generatePerformanceGraph, {
      graphs,
    });
  }

  AddOCRNotMappedPropertyData = (
    data: AddOCRNotMappedPropertyReqBodyModel,
  ): Observable<ApiResponseModel> => {
    return this.http.post<ApiResponseModel>(
      ApiEndPoint.addOCRNotMappedPropertyData,
      data,
    );
  };

  UpdateOCRNotMappedPropertyData = (
    data: AddOCRNotMappedPropertyReqBodyModel[],
  ): Observable<AddOCRNotMappedPropertyReqBodyModel> => {
    return this.http.post<AddOCRNotMappedPropertyReqBodyModel>(
      ApiEndPoint.updateOCRNotMappedPropertyData,
      { data },
    );
  };
  addMapOcrProperty = (
    data: AddOCRNotMappedPropertyReqBodyModel[],
  ): Observable<AddOCRNotMappedPropertyReqBodyModel> => {
    return this.http.post<AddOCRNotMappedPropertyReqBodyModel>(
      ApiEndPoint.addMapOcrProperty,
      { data },
    );
  };

  getUserEmailFromEmployeeList(
    search = "",
    limit = 20,
    lastEmail: string | null = null,
  ) {
    let params: any = {
      limit: limit.toString(),
    };
    if (search) {
      params.search = search;
    }
    if (lastEmail) {
      params.lastEmail = lastEmail;
    }

    return this.http.get<UserEmailResponse>(
      ApiEndPoint.getUserEmailsFromEmployeesList,
      {
        headers: this.getAuthHeaders(),
        params,
      },
    );
  }
  GetTODOActionsBogPro(
    email: string,
    filters: BogActionFilter[],
  ): Observable<BogTodoActionsResponse> {
    const payload: BogActionsRequest = {
      data: {
        email,
        filters,
      },
    };
    return this.http.post<BogTodoActionsResponse>(
      `${ApiEndPoint.getTODOActionsBogPro}`,
      payload,
      {
        headers: this.getAuthHeaders(),
      },
    );
  }

  CreateSession = (data: { user_id: string }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.createSession, data);
  };

  CreateTriviaTutorSession = (data: {
    user_id: string;
    topic_name?: string;
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.createTriviaTutorSession, data);
  };

  ExecuteTriviaTutor = (data: {
    user_id: string;
    session_id?: string;
    message: string;
    topic_name?: string;
    topic_id?: string;
    user_name?: string;
    user_profile_image?: string;
    reference_url?: string | string[];
    triviaId?: string;
    questionId?: string;
    topic_doc_id?: string;
    lesson_doc_id?: string;
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.executeTriviaTutor, data);
  };

  IngestTriviaDocument = (data: {
    user_id: string;
    session_id: string;
    name: string;
    url: string;
    file_type: string;
    topic: string;
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.ingestTriviaDocument, data);
  };

  DeleteTriviaDocument = (data: {
    user_id: string;
    session_id: string;
    topic: string;
    file_name: string;
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.deleteTriviaDocument, data);
  };

  UpdateChallenge = (data: {
    triviaId: string;
    questionId: string;
    status?: string;
    active?: boolean;
    title?: string;
    options?: any[];
    answer?: string | string[];
    correct_answer?: string | string[];
    answer_type?: "single" | "multiple";
    explanation?: string;
    is_accepted?: boolean;
    question_image_url?: string;
    segments?: string[];
    sub_segments?: string[];
    delete_permanently?: boolean;
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.updateChallenge, data);
  };

  GetFollowUpActionsBogPro(
    email: string,
    filters: BogActionFilter[],
  ): Observable<BogFollowUpActionsResponse> {
    const payload: BogActionsRequest = {
      data: {
        email,
        filters,
      },
    };
    return this.http.post<BogFollowUpActionsResponse>(
      `${ApiEndPoint.getFollowUpActionsBogPro}`,
      payload,
      {
        headers: this.getAuthHeaders(),
      },
    );
  }

  ActionClosureBogPro(
    data: ActionClosureModel,
  ): Observable<BogActionsResponseModel> {
    const payload = {
      data: data,
    };

    return this.http.post<BogActionsResponseModel>(
      `${ApiEndPoint.actionClosureBogPro}`,
      payload,
      {
        headers: this.getAuthHeaders(),
      },
    );
  }

  ReAssignActionBogPro(
    email: string,
    data: ReAssignActionModel,
  ): Observable<BogActionsResponseModel> {
    const payload = {
      email: email,
      data: data,
    };
    return this.http.post<BogActionsResponseModel>(
      `${ApiEndPoint.reAssignActionBogPro}`,
      payload,
      {
        headers: this.getAuthHeaders(),
      },
    );
  }
  BogProImplementationReport = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.bogProImplementationReport, data);
  };

  SecurityMappingReport = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.securityMappingReport, data);
  };

  SendMailForBogProImplementationReport = (data: any): Observable<any> => {
    return this.http.post<any>(
      ApiEndPoint.sendMailForBogProImplementationReport,
      data,
    );
  };

  GetActiveRegionsCountryGroupBogPro = () => {
    return this.http.get<any>(ApiEndPoint.getActiveRegionsCountryGroupBogPro);
  };

  getAllPerformanceLocationBogPro(
    type: string,
  ): Observable<PerformanceLocationResponse> {
    const reqObj = { type };

    return this.http
      .post<PerformanceLocationResponse>(
        ApiEndPoint.getAllPerformanceLocationBogPro,
        reqObj,
        {
          headers: this.getAuthHeaders(),
          context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
        },
      )
      .pipe(shareReplay(1));
  }

  getAllPerformanceLocationBogProFiltered(
    type: string,
    user: UserModel,
  ): Observable<PerformanceLocationResponse> {
    const reqObj = {
      type,
      userInfo: {
        bogUserFields: {
          profile: user?.bogUserFields?.profile ?? "",
          shield_user: user?.bogUserFields?.shield_user ?? false,
        },
        defaultLocation: {
          region: {
            locationName: user?.defaultLocation?.region?.locationName ?? "",
          },
          country: {
            locationName: user?.defaultLocation?.country?.locationName ?? "",
            // locationName: "Hungary",
          },
        },
      },
    };

    return this.http
      .post<PerformanceLocationResponse>(
        ApiEndPoint.getAllPerformanceLocationBogProFiltered,
        reqObj,
        {
          headers: this.getAuthHeaders(),
          context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
        },
      )
      .pipe(shareReplay(1));
  }

  addPerformanceUserSubscriptionsBogPro(payload: {
    data: {
      email: string;
      fullName?: string;
      group: boolean;
      region: string[];
      country: string[];
      unit: string[];
    };
  }): Observable<any> {
    return this.http.post<any>(
      ApiEndPoint.addPerformanceUserSubscriptionsBogPro,
      payload,
    );
  }

  getPerformanceUserSubscriptionsBogPro(email: string): Observable<any> {
    return this.http.get<any>(
      `${ApiEndPoint.getPerformanceUserSubscriptionsBogPro}?email=${encodeURIComponent(email)}`,
    );
  }

  // generatePerformancePdfReportBogPro(reqObj: any) {
  //   return this.http.post<any>(
  //     ApiEndPoint.generatePerformancePdfReportBogPro,
  //     reqObj,
  //     {
  //       headers: this.getAuthHeaders(),
  //       context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
  //     },
  //   );
  // }

  sendBulkMail(reqObj: GenerateReportRequest) {
    return this.http.post<{ success: boolean; job_id: string }>(
      ApiEndPoint.sendBulkPerformanceEmailReportMails,
      reqObj,
    );
  }
  generateReportAndSendEmail(
    reqObj: GenerateReportRequest,
  ): Observable<GenerateReportResponse> {
    return this.http.post<GenerateReportResponse>(
      ApiEndPoint.generateReportAndSendEmail,
      reqObj,
    );
  }

  saveAllPerformanceReportsBogPro(): Observable<any> {
    return this.http.post<any>(
      ApiEndPoint.saveAllPerformanceReportsBogPro,
      {},
      {
        headers: this.getAuthHeaders(),
        context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
      },
    );
  }

  getMultipleCountryHighLowDataBogPro(reqObj: any) {
    return this.http.post<any>(
      ApiEndPoint.getMultipleCountryHighLowDataBogPro,
      reqObj,
      {
        headers: this.getAuthHeaders(),
        context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
      },
    );
  }

  getMultipleUnitHighLowDataBogPro(reqObj: any) {
    return this.http.post<any>(
      ApiEndPoint.getMultipleUnitHighLowDataBogPro,
      reqObj,
      {
        headers: this.getAuthHeaders(),
        context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
      },
    );
  }
  getSendAllEmailstatus(jobId: string) {
    return this.http.get<GenerateStatusReportResponse>(
      `${ApiEndPoint.getReportJobStatus}?job_id=${jobId}`,
    );
  }

  cancelReportJob(
    progressId: string,
  ): Observable<{ success: boolean; message?: string }> {
    return this.http.post<{ success: boolean; message?: string }>(
      ApiEndPoint.cancelReportJob,
      { progressId },
    );
  }

  cancelBulkEmailJob(
    jobId: string,
  ): Observable<{ success: boolean; message?: string }> {
    return this.http.post<{ success: boolean; message?: string }>(
      ApiEndPoint.cancelBulkEmailJob,
      { jobId },
    );
  }

  getSendBulkEmailstatus(jobId: string) {
    return this.http.get<GenerateStatusReportResponse>(
      `${ApiEndPoint.getSendBulkEmailstatus}?job_id=${jobId}`,
    );
  }
  getUserActiveJobs(email: string = "") {
    return this.http.post<ActiveJobsResponse>(ApiEndPoint.getUserActiveJobs, {
      email,
    });
  }

  getUserActiveEmailJobs(email: string = "") {
    return this.http.post<ActiveEmailJobsResponse>(
      ApiEndPoint.getUserActiveEmailJobs,
      { email },
    );
  }

  getBulkEmailJobStatus(jobId: string) {
    return this.http.get<BulkEmailStatusResponse>(
      `${ApiEndPoint.getSendBulkEmailstatus}?job_id=${jobId}`,
    );
  }

  getSystemActivePerformanceJobs(): Observable<SystemActiveJobsResponse> {
    return this.http.get<any>(ApiEndPoint.getSystemActivePerformanceJobs, {
      headers: this.getAuthHeaders(),
    });
  }

  getLocationTrackingStatus(month: string, type: string) {
    return this.http.get<LocationTrackingResponse>(
      `${ApiEndPoint.getLocationTrackingStatus}?month=${month}&type=${type}`,
    );
  }

  syncApppDetails(lastSyncedAt: string) {
    return this.http.post<SyncApppDetailsResponseModel>(
      ApiEndPoint.syncApppDetails,
      {
        lastSyncedAt,
      },
    );
  }
  GetAUserActions(email: string): Observable<ActionsResponse> {
    return this.http.post<ActionsResponse>(ApiEndPoint.getAUserActions, {
      email,
    });
  }

  GetAUserFindings(email: string): Observable<FindingsResponse> {
    return this.http.post<FindingsResponse>(ApiEndPoint.getAUserFindings, {
      email,
    });
  }

  GetAFinding(
    findingId: string,
    assessmentId: string,
  ): Observable<ActionResponse> {
    return this.http.post<ActionResponse>(ApiEndPoint.getAFinding, {
      findingId,
      assessmentId,
    });
  }

  GetLocationHirerchyConfig = (): Observable<any> => {
    return this.http.get<any>(`${ApiEndPoint.getLocationHirerchyConfig}`, {
      headers: this.getAuthHeaders(),
    });
  };

  UpdateLocationHirerchyConfig = (data: any): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.updateLocationHirerchyConfig, data, {
      headers: this.getAuthHeaders(),
    });
  };

  GetChildDataByIdBogPro = (data: any): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.getChildDataByIdBogPro}`, data, {
      headers: this.getAuthHeaders(),
    });
  };

  AddLocationMasterLevelBogPro = (data: any): Observable<any> => {
    return this.http.post<any>(
      `${ApiEndPoint.addLocationMasterLevelBogPro}`,
      data,
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  TransferLevelDataBogPro = (data: any): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.transferLevelDataBogPro}`, data, {
      headers: this.getAuthHeaders(),
    });
  };

  UpdateLevelInfoBogPro = (data: any): Observable<any> => {
    return this.http.post<any>(`${ApiEndPoint.updateLevelInfoBogPro}`, data, {
      headers: this.getAuthHeaders(),
    });
  };

  getHseExcellenceUserDataBogPro = (data: {
    user_id: string;
    filters?: { date?: string };
  }): Observable<any> => {
    return this.http.post<any>(
      ApiEndPoint.getHseExcellenceUserDataBogPro,
      { data },
      {
        headers: this.getAuthHeaders(),
        context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
      },
    );
  };

  updateWeeklyDataAnswersBogPro = (data: {
    key: string;
    week: string;
    bog_intelligence?: boolean;
    updateThumbs?: boolean;
    how_busy?: string;
    how_feel?: number | null;
    hse_que?: { question: string; answer: number | null } | null;
    updatedQue?: boolean;
  }): Observable<any> => {
    return this.http.post<any>(
      ApiEndPoint.updateWeeklyDataAnswersBogPro,
      { data },
      {
        headers: this.getAuthHeaders(),
        context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
      },
    );
  };

  getHseUserQuestionsBogPro = (): Observable<any> => {
    return this.http.post<any>(
      ApiEndPoint.getHseUserQuestionsBogPro,
      { data: {} },
      {
        headers: this.getAuthHeaders(),
        context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
      },
    );
  };

  getBMBaseBogPro(data: { data: Record<string, any> }): Observable<any> {
    return this.http.post<any>(ApiEndPoint.getBMBaseBogPro, data, {
      headers: this.getAuthHeaders(),
      context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
    });
  }

  getBMFitnessBogPro(data: {
    data: {
      filters: { country: string; allRegion: string };
      month: number;
      category: string;
    };
  }): Observable<any> {
    return this.http.post<any>(ApiEndPoint.getBMFitnessBogPro, data, {
      headers: this.getAuthHeaders(),
      context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
    });
  }

  getBMScorecardBogPro(data: {
    filters: { country: string; allRegion: string };
    quarter: string;
    category: string;
  }): Observable<any> {
    return this.http.post<any>(ApiEndPoint.getBMScorecardBogPro, data, {
      headers: this.getAuthHeaders(),
      context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
    });
  }

  getBMCreBogPro(data: {
    filters: { country: string; allRegion: string };
    quarter: string;
    category: string;
  }): Observable<any> {
    return this.http.post<any>(ApiEndPoint.getBMCreBogPro, data, {
      headers: this.getAuthHeaders(),
      context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
    });
  }

  getBMIncidentHistoryBogPro(data: {
    filters: { country: string; allRegion: string };
    month: number;
    category: string;
  }): Observable<any> {
    return this.http.post<any>(ApiEndPoint.getBMIncidentHistoryBogPro, data, {
      headers: this.getAuthHeaders(),
      context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
    });
  }

  getBMEnvironmentBogPro(data: {
    data: {
      filters: { country: string; allRegion: string };
      month: number;
      category: string;
    };
  }): Observable<any> {
    return this.http.post<any>(ApiEndPoint.getBMEnvironmentBogPro, data, {
      headers: this.getAuthHeaders(),
      context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
    });
  }

  getBMEngagementBogPro(data: {
    data: {
      filters: { country: string; allRegion: string };
      month: number;
      category: string;
    };
  }): Observable<any> {
    return this.http.post<any>(ApiEndPoint.getBMEngagementBogPro, data, {
      headers: this.getAuthHeaders(),
      context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
    });
  }

  getBMRoadBogPro(data: {
    filters: { country: string; allRegion: string };
    month: number;
    category: string;
  }): Observable<any> {
    return this.http.post<any>(ApiEndPoint.getBMRoadBogPro, data, {
      headers: this.getAuthHeaders(),
      context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, true),
    });
  }

  UpdateRatingForEIProcedure = (
    data: EIRatingUpdateModel,
  ): Observable<EiRatingResponse> => {
    return this.http.post<EiRatingResponse>(ApiEndPoint.eiRating, data);
  };

  getCountryPredictScoreData(date: string, page: number, limit: number) {
    const payload = { date, page, limit };
    return this.http.post<any>(
      ApiEndPoint.getAiPlatformScoreByPeriods,
      payload,
      {
        headers: this.getAuthHeaders(),
        context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, false),
      },
    );
  }

  getPredictAUScoreByPeriods(date: string, page: number, limit: number) {
    const payload = { date, page, limit };
    return this.http.post<any>(
      ApiEndPoint.getPredictAUScoreByPeriods,
      payload,
      {
        headers: this.getAuthHeaders(),
        context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, false),
      },
    );
  }

  getAiPlatformUnitScoreByPeriods(date: string, page: number, limit: number) {
    const payload = { date, page, limit };
    return this.http.post<any>(
      ApiEndPoint.getAiPlatformUnitScoreByPeriods,
      payload,
      {
        headers: this.getAuthHeaders(),
        context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, false),
      },
    );
  }

  submitScoresForApproval(
    date: string,
    tab: "fitness" | "predict_au",
    submitted_by: string,
  ) {
    const payload = { date, tab, submitted_by };
    return this.http.post<any>(ApiEndPoint.submitScoresForApproval, payload, {
      headers: this.getAuthHeaders(),
      context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, false),
    });
  }

  revokeScoreSubmission(
    date: string,
    tab: "fitness" | "predict_au",
    revoked_by: string,
  ) {
    const payload = { date, tab, revoked_by };
    return this.http.post<any>(ApiEndPoint.revokeScoreSubmission, payload, {
      headers: this.getAuthHeaders(),
      context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, false),
    });
  }

  rejectScoreSubmission(
    date: string,
    tab: "fitness" | "predict_au",
    rejected_by: string,
    reason?: string,
  ) {
    const payload: any = { date, tab, rejected_by };
    if (reason) payload.reason = reason;
    return this.http.post<any>(ApiEndPoint.rejectScoreSubmission, payload, {
      headers: this.getAuthHeaders(),
      context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, false),
    });
  }

  approveFitnessScores(date: string, approved_by: string) {
    const payload = { date, approved_by };
    return this.http.post<any>(ApiEndPoint.approveFitnessScores, payload, {
      headers: this.getAuthHeaders(),
      context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, false),
    });
  }

  approvePredictAUScores(date: string, approved_by: string) {
    const payload = { date, approved_by };
    return this.http.post<any>(ApiEndPoint.approvePredictAUScores, payload, {
      headers: this.getAuthHeaders(),
      context: new HttpContext().set(SKIP_AUTH_INTERCEPTOR, false),
    });
  }

  MaterialRequestUpdateToEditors = (
    data: MaterialRequestUpdateToEditorsRequestBody,
  ): Observable<HttpResponseModel> => {
    return this.http.post<HttpResponseModel>(
      ApiEndPoint.materialRequestUpdateToEditors,
      data,
    );
  };

  updateSAPKeyCode = (data: {
    siteId: string;
    sap_key_code: string;
  }): Observable<UpdateSapKeyCodeResponseModel> => {
    return this.http.post<UpdateSapKeyCodeResponseModel>(
      ApiEndPoint.updateSapKeyCode,
      data,
    );
  };

  TestIcareConnection = (payload: {
    data: {
      username: string;
      password: string;
      reportingApiUrl: string;
      restApiUrl: string;
      secretToken: string;
    };
  }): Observable<{ success: boolean; message?: string }> => {
    return this.http.post<{ success: boolean; message?: string }>(
      ApiEndPoint.testIcareConnection,
      payload,
      { headers: this.getAuthHeaders() },
    );
  };

  SyncIcareLocations = (payload: {
    data: {
      username: string;
      password: string;
      reportingApiUrl: string;
      secretToken: string;
    };
  }): Observable<{ success: boolean; count: number; message?: string }> => {
    return this.http.post<{
      success: boolean;
      count: number;
      message?: string;
    }>(ApiEndPoint.syncIcareLocations, payload, {
      headers: this.getAuthHeaders(),
    });
  };

  SyncIcareDepartments = (payload: {
    data: {
      username: string;
      password: string;
      reportingApiUrl: string;
      secretToken: string;
    };
  }): Observable<{ success: boolean; count: number; message?: string }> => {
    return this.http.post<{
      success: boolean;
      count: number;
      message?: string;
    }>(ApiEndPoint.syncIcareDepartments, payload, {
      headers: this.getAuthHeaders(),
    });
  };

  SyncIcareSecondaryWorkgroups = (payload: {
    data: {
      username: string;
      password: string;
      reportingApiUrl: string;
      secretToken: string;
    };
  }): Observable<{ success: boolean; count: number; message?: string }> => {
    return this.http.post<{
      success: boolean;
      count: number;
      message?: string;
    }>(ApiEndPoint.syncIcareSecondaryWorkgroups, payload, {
      headers: this.getAuthHeaders(),
    });
  };
  GetAllMasterSubAssets = (): Observable<AllSubAssetMasterDataResponse> => {
    return this.http.get<AllSubAssetMasterDataResponse>(
      ApiEndPoint.getAllSubAssetList,
    );
  };

  AddMasterSubAsset = (
    data: SubAssetMasterDataModel,
  ): Observable<AddMasterSubAssetResponse> => {
    return this.http.post<AddMasterSubAssetResponse>(
      ApiEndPoint.addMasterSubAsset,
      data,
    );
  };

  AddMasterSubAssetAsDraft = (
    data: SubAssetMasterDataModel,
  ): Observable<AddMasterSubAssetResponse> => {
    return this.http.post<AddMasterSubAssetResponse>(
      ApiEndPoint.addMasterSubAssetAsDraft,
      data,
    );
  };

  UpdateMasterSubAsset = (
    data: SubAssetMasterDataModel,
  ): Observable<AddMasterSubAssetResponse> => {
    return this.http.post<AddMasterSubAssetResponse>(
      ApiEndPoint.updateMasterSubAsset,
      data,
    );
  };

  DeleteMasterSubAsset = (data: {
    id: string;
  }): Observable<DeleteMasterSubAssetResponse> => {
    return this.http.post<DeleteMasterSubAssetResponse>(
      ApiEndPoint.deleteMasterSubAsset,
      data,
    );
  };

  GetMasterSubAssetById = (data: {
    id: string;
  }): Observable<GetMasterSubAssetByIdResponse> => {
    return this.http.post<GetMasterSubAssetByIdResponse>(
      ApiEndPoint.getMasterSubAssetById,
      data,
    );
  };

  GetAllMasterDataList = (): Observable<AllAssetMasterDataResponse> => {
    return this.http.get<AllAssetMasterDataResponse>(
      ApiEndPoint.getAllAssetMasterDataList,
    );
  };

  GetAssetMasterById = (data: {
    id: string;
  }): Observable<GetAssetMasterByIdResponse> => {
    return this.http.post<GetAssetMasterByIdResponse>(
      ApiEndPoint.getAssetMasterById,
      data,
    );
  };

  AddSubAssetToMasterAsset = (
    data: AddSubAssetToMasterAssetPayload,
  ): Observable<SubAssetMasterAssetResponse> => {
    return this.http.post<SubAssetMasterAssetResponse>(
      ApiEndPoint.addSubAssetToMasterAsset,
      data,
    );
  };

  RemoveSubAssetFromMasterAsset = (
    data: RemoveSubAssetFromMasterAssetPayload,
  ): Observable<SubAssetMasterAssetResponse> => {
    return this.http.post<SubAssetMasterAssetResponse>(
      ApiEndPoint.removeSubAssetFromMasterAsset,
      data,
    );
  };

  UpdateSubAssetInMasterAsset = (
    data: AddSubAssetToMasterAssetPayload,
  ): Observable<SubAssetMasterAssetResponse> => {
    return this.http.post<SubAssetMasterAssetResponse>(
      ApiEndPoint.updateSubAssetInMasterAsset,
      data,
    );
  };
  GetAllDataEiMaster = (masterType: string): Observable<any> => {
    return this.http.post<HttpResponseModel>(ApiEndPoint.getAllDataEiMaster, {
      masterType,
    });
  };
  AddEiMasterData = (data: {
    masterType: string;
    data: any;
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.addEiMasterData, data);
  };
  DeleteEiMasterData = (data: {
    masterType: string;
    data: any;
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.deleteEiMasterData, data);
  };
  UpdateEiMasterData = (data: {
    masterType: string;
    data: any;
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.updateEiMasterData, data);
  };

  GetProductLines = (): Observable<GetProductLinesResponseModel> => {
    return this.http.get<GetProductLinesResponseModel>(
      ApiEndPoint.getProductLines,
    );
  };

  AddProductLine = (
    data: ProductLineMasterTypeModel,
  ): Observable<AddProductLineResponseModel> => {
    return this.http.post<AddProductLineResponseModel>(
      ApiEndPoint.addProductLine,
      data,
    );
  };

  UpdateProductLine = (
    data: ProductLineMasterTypeModel & { id: string },
  ): Observable<UpdateProductLineResponseModel> => {
    return this.http.post<UpdateProductLineResponseModel>(
      ApiEndPoint.updateProductLine,
      data,
    );
  };

  DeleteProductLine = (data: {
    id: string;
  }): Observable<DeleteProductLineResponseModel> => {
    return this.http.post<DeleteProductLineResponseModel>(
      ApiEndPoint.deleteProductLine,
      data,
    );
  };

  // ── Site Master: Transports Explosives ──────────────────────────────────────

  GetTransportsExplosives =
    (): Observable<GetTransportsExplosivesResponseModel> => {
      return this.http.get<GetTransportsExplosivesResponseModel>(
        ApiEndPoint.getTransportsExplosives,
      );
    };

  AddTransportsExplosive = (
    data: TransportsExplosivesMasterTypeModel,
  ): Observable<AddTransportsExplosiveResponseModel> => {
    return this.http.post<AddTransportsExplosiveResponseModel>(
      ApiEndPoint.addTransportsExplosive,
      data,
    );
  };

  UpdateTransportsExplosive = (
    data: TransportsExplosivesMasterTypeModel & { id: string },
  ): Observable<UpdateTransportsExplosiveResponseModel> => {
    return this.http.post<UpdateTransportsExplosiveResponseModel>(
      ApiEndPoint.updateTransportsExplosive,
      data,
    );
  };

  DeleteTransportsExplosive = (data: {
    id: string;
  }): Observable<DeleteTransportsExplosiveResponseModel> => {
    return this.http.post<DeleteTransportsExplosiveResponseModel>(
      ApiEndPoint.deleteTransportsExplosive,
      data,
    );
  };

  // ── Site Master: Zone Type ──────────────────────────────────────────────────

  GetZoneTypes = (): Observable<GetZoneTypesResponseModel> => {
    return this.http.get<GetZoneTypesResponseModel>(ApiEndPoint.getZoneTypes);
  };

  AddZoneType = (
    data: ZoneMasterTypeModel,
  ): Observable<AddZoneTypeResponseModel> => {
    return this.http.post<AddZoneTypeResponseModel>(
      ApiEndPoint.addZoneType,
      data,
    );
  };

  UpdateZoneType = (
    data: ZoneMasterTypeModel & { id: string },
  ): Observable<UpdateZoneTypeResponseModel> => {
    return this.http.post<UpdateZoneTypeResponseModel>(
      ApiEndPoint.updateZoneType,
      data,
    );
  };

  DeleteZoneType = (data: {
    id: string;
  }): Observable<DeleteZoneTypeResponseModel> => {
    return this.http.post<DeleteZoneTypeResponseModel>(
      ApiEndPoint.deleteZoneType,
      data,
    );
  };

  GetFlameReviewAssets = (data: { last_doc_id?: string }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.getFlameReviewAssets, data, {
      headers: this.getAuthHeaders(),
    });
  };

  GetFlameReviewWithAllGames = (data: {
    last_doc_id?: string;
    filters?: {
      game1?: boolean;
      game2?: boolean;
      game3?: boolean;
      verified?: boolean;
    };
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.getFlameReviewWithAllGames, data, {
      headers: this.getAuthHeaders(),
    });
  };

  GetFlameAssetGameData = (data: { asset_id: string }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.getFlameAssetGameData, data, {
      headers: this.getAuthHeaders(),
    });
  };

  VerifyFlameReviewAsset = (data: {
    asset_id: string;
    is_control_verified: boolean;
  }): Observable<any> => {
    return this.http.post<any>(ApiEndPoint.verifyFlameReviewAsset, data, {
      headers: this.getAuthHeaders(),
    });
  };
  // Material Registration
  addMaterialMasterRegistration = (
    data: MaterialRegistrationItem,
  ): Observable<MaterialRegistrationItem> => {
    return this.http.post<MaterialRegistrationItem>(
      ApiEndPoint.addMaterialMasterRegistration,
      { data },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  updateMaterialMasterRegistration = (
    data: MaterialRegistrationItem,
  ): Observable<MaterialRegistrationItem> => {
    return this.http.post<MaterialRegistrationItem>(
      ApiEndPoint.updateMaterialMasterRegistration,
      { data },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  deleteMaterialMasterRegistration = (
    data: MaterialRegistrationItem,
  ): Observable<MaterialRegistrationItem> => {
    return this.http.post<MaterialRegistrationItem>(
      ApiEndPoint.deleteMaterialMasterRegistration,
      { data },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  addMaterialMasterBannedWaste = (
    data: BannedWasteItem,
  ): Observable<BannedWasteItem> => {
    return this.http.post<BannedWasteItem>(
      ApiEndPoint.addMaterialMasterBannedWaste,
      { data },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  updateMaterialMasterBannedWaste = (
    data: BannedWasteItem,
  ): Observable<BannedWasteItem> => {
    return this.http.post<BannedWasteItem>(
      ApiEndPoint.updateMaterialMasterBannedWaste,
      { data },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  deleteMaterialMasterBannedWaste = (
    data: BannedWasteItem,
  ): Observable<BannedWasteItem> => {
    return this.http.post<BannedWasteItem>(
      ApiEndPoint.deleteMaterialMasterBannedWaste,
      { data },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  // Hazards
  addMaterialMasterHazard = (
    data: MM_Hazard_EnvironmentModel,
  ): Observable<MM_Hazard_EnvironmentModel> => {
    return this.http.post<MM_Hazard_EnvironmentModel>(
      ApiEndPoint.addHazardMasterMaterial,
      { data },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  updateMaterialMasterHazard = (
    data: MM_Hazard_EnvironmentModel,
  ): Observable<MM_Hazard_EnvironmentModel> => {
    return this.http.post<MM_Hazard_EnvironmentModel>(
      ApiEndPoint.updateMaterialMasterHazard,
      { data },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  deleteMaterialMasterHazard = (
    data: MM_Hazard_EnvironmentModel,
  ): Observable<MM_Hazard_EnvironmentModel> => {
    return this.http.post<MM_Hazard_EnvironmentModel>(
      ApiEndPoint.deleteMaterialMasterHazard,
      { data },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  addMaterialControl = (
    data: MaterialControlConfigModel,
  ): Observable<MaterialControlConfigModel> => {
    return this.http.post<MaterialControlConfigModel>(
      ApiEndPoint.addMaterialControl,
      { data },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  updateMaterialMasterControl = (
    data: MaterialControlConfigModel,
  ): Observable<MaterialControlConfigModel> => {
    return this.http.post<MaterialControlConfigModel>(
      ApiEndPoint.updateMaterialMasterControl,
      { data },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  addMaterialMasterOCRLabel = (
    data: OCRLabelMapping,
  ): Observable<OCRLabelMapping> => {
    return this.http.post<OCRLabelMapping>(
      ApiEndPoint.addMaterialMasterOCRLabel,
      { data },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  updateMaterialMasterOCRLabel = (
    data: OCRLabelMapping,
  ): Observable<OCRLabelMapping> => {
    return this.http.post<OCRLabelMapping>(
      ApiEndPoint.updateMaterialMasterOCRLabel,
      { data },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };
  deleteMaterialMasterOCRLabel = (
    data: OCRLabelMapping,
  ): Observable<OCRLabelMapping> => {
    return this.http.post<OCRLabelMapping>(
      ApiEndPoint.deleteMaterialMasterOCRLabel,
      { data },
      {
        headers: this.getAuthHeaders(),
      },
    );
  };

  // ── Site Security Mapping: Categories ───────────────────────────────────────

  AddSiteSecurityCategory = (
    data: Omit<SecurityCategoryModel, "id">,
  ): Observable<AddSecurityCategoryResponseModel> => {
    return this.http.post<AddSecurityCategoryResponseModel>(
      ApiEndPoint.addSiteSecurityCategory,
      data,
    );
  };

  UpdateSiteSecurityCategory = (
    data: Partial<SecurityCategoryModel> & { id: string },
  ): Observable<UpdateSecurityCategoryResponseModel> => {
    return this.http.post<UpdateSecurityCategoryResponseModel>(
      ApiEndPoint.updateSiteSecurityCategory,
      data,
    );
  };

  DeleteSiteSecurityCategory = (data: {
    id: string;
  }): Observable<DeleteSecurityCategoryResponseModel> => {
    return this.http.post<DeleteSecurityCategoryResponseModel>(
      ApiEndPoint.deleteSiteSecurityCategory,
      data,
    );
  };

  // ── Site Security Mapping: Points of interest ───────────────────────────────

  AddSiteSecurityPoi = (
    data: Omit<SecurityPoiModel, "id">,
  ): Observable<AddSecurityPoiResponseModel> => {
    return this.http.post<AddSecurityPoiResponseModel>(
      ApiEndPoint.addSiteSecurityPoi,
      data,
    );
  };

  UpdateSiteSecurityPoi = (
    data: Partial<SecurityPoiModel> & { id: string },
  ): Observable<UpdateSecurityPoiResponseModel> => {
    return this.http.post<UpdateSecurityPoiResponseModel>(
      ApiEndPoint.updateSiteSecurityPoi,
      data,
    );
  };

  DeleteSiteSecurityPoi = (data: {
    id: string;
  }): Observable<DeleteSecurityPoiResponseModel> => {
    return this.http.post<DeleteSecurityPoiResponseModel>(
      ApiEndPoint.deleteSiteSecurityPoi,
      data,
    );
  };

  // ── Security Mapping (Settings, per country): save / update / delete ─────────

  AddSecurityLocation = (
    data: SecurityLocationSaveRequestModel,
  ): Observable<SecurityMappingResponseModel> => {
    return this.http.post<SecurityMappingResponseModel>(
      ApiEndPoint.addSecurityLocation,
      data,
    );
  };

  UpdateSecurityLocation = (
    data: SecurityLocationSaveRequestModel,
  ): Observable<SecurityMappingResponseModel> => {
    return this.http.post<SecurityMappingResponseModel>(
      ApiEndPoint.updateSecurityLocation,
      data,
    );
  };

  DeleteSecurityLocation = (
    data: SecurityMappingDeleteRequestModel,
  ): Observable<SecurityMappingResponseModel> => {
    return this.http.post<SecurityMappingResponseModel>(
      ApiEndPoint.deleteSecurityLocation,
      data,
    );
  };

  AddSecurityRoute = (
    data: SecurityRouteSaveRequestModel,
  ): Observable<SecurityMappingResponseModel> => {
    return this.http.post<SecurityMappingResponseModel>(
      ApiEndPoint.addSecurityRoute,
      data,
    );
  };

  UpdateSecurityRoute = (
    data: SecurityRouteSaveRequestModel,
  ): Observable<SecurityMappingResponseModel> => {
    return this.http.post<SecurityMappingResponseModel>(
      ApiEndPoint.updateSecurityRoute,
      data,
    );
  };

  DeleteSecurityRoute = (
    data: SecurityMappingDeleteRequestModel,
  ): Observable<SecurityMappingResponseModel> => {
    return this.http.post<SecurityMappingResponseModel>(
      ApiEndPoint.deleteSecurityRoute,
      data,
    );
  };
}
